// pages/AudioAnalyzer.jsx
import React from "react";
import ProjectTemplate from "../components/ProjectTemplate";
import { projects } from "../data/projectsData";

const AudioAnalyzer = () => (
  <>
    <title>Audio Analyzer - Arthur Efremenko</title>
    <meta name="description" content={projects.audioAnalyzer.description} />
    <ProjectTemplate
      project={projects.audioAnalyzer}
      screenshots={projects.audioAnalyzer.screenshots}
    />
  </>
);

export default AudioAnalyzer;
